import PasswordResetRequestForm from '../../features/Login/PasswordResetRequestForm';

export default function PasswordResetRequestPage() {
    return <>
        <PasswordResetRequestForm />
    </>;
}
